import React, { useState } from "react";
import { ListItem, ListItemIcon, ListItemText, Button } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import UploadIcon from "@material-ui/icons/CloudUpload";

import localforage from "localforage";
import axios from "axios";

import { v4 as uuidv4 } from "uuid";

import { getDatabaseName, getAllDataFromForm, removeReady } from "../../utils/helpers";
import { useUser } from "../../auth/useUser";

export default function SendData({ isOnline, onSent, onError }) {
  const [sending, setSending] = useState(false);
  const [showProblem, _showProblem] = useState(false);
  const [sendingMessage, setSendingMessage] = useState("");
  const [{ forms, ...userData }] = useUser();

  const handleSend = async () => {
    setSending(true);

    const group_code = uuidv4();

    try {
      for (let idx in forms) {
        const form = forms[idx];
        const databaseName = getDatabaseName(userData.user.id, form.id);

        const store = localforage.createInstance({
          name: databaseName,
        });

        const length = await store.length();

        if (length > 0) {
          setSendingMessage(`Enviando ${form.title}...`);

          onSent(); // vai para a home

          // Somente os itens com ready -> true
          const allFormsData = await getAllDataFromForm(store, true);

          try {
            for (let row of allFormsData) {

              // Send to API

              const { status, data } = await axios.post(`${process.env.REACT_APP_SERVER}collect-service/save-one`, {
                formId: form.id,
                data: row,
                group_code,
              });

              await store.setItem(row.key, { ...row, removedTS: Date.now(), sentID: data.id });
            }
          } catch (e) {
            _showProblem(true);
          }

        }
      }

      setSendingMessage("Dados enviados!");
    } catch (err) {
      onError(err);
      setSendingMessage("Falha no envio, verifique sua conexão.");
      throw err;
    } finally {
      setTimeout(() => {
        setSending(false);
        setSendingMessage("");
      }, 3000);
    }
  };

  return (<>
    <ListItem button onClick={handleSend} disabled={!isOnline || sending || !forms}>
      <ListItemIcon>
        <UploadIcon />
      </ListItemIcon>
      <ListItemText primary={sendingMessage || "Enviar Coletas"} />
    </ListItem>

    <Dialog
      open={showProblem}
      onClose={() => _showProblem(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Seu usuário está sem permissão para envio de coletas!"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Entre em contato com a administração.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => _showProblem(false)} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  </>);
}
